import { render } from "./tertary.vue?vue&type=template&id=3cf5538e&scoped=true"
import script from "./tertary.vue?vue&type=script&lang=js"
export * from "./tertary.vue?vue&type=script&lang=js"

import "./tertary.vue?vue&type=style&index=0&id=3cf5538e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf5538e"]])

export default __exports__